import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IdNome} from '../model/id-nome.model';

@Injectable({
  providedIn: 'root'
})
export class TipoDocumentoService {
  urlBase = `${environment.urlBase}/tipo-documento`;

  constructor(private  http: HttpClient) { }

  buscarTiposDocumento(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(this.urlBase);
  }
}
